// Author Shi Wen Long
// Date 2021-08-25 12:04:20

class SithMesPrdSdProjectNetwork {
constructor({
        id = null,
        projectDefinition = '',
        networkWbs = '',
        networkCode = '',
        decription = '',
        salesOrder = '',
        itemNumber = '',
        syncStatus = '',
        remark = ''}
= {}) {
    this.id = id;
    this.projectDefinition = projectDefinition;
    this.networkWbs = networkWbs;
    this.networkCode = networkCode;
    this.decription = decription;
    this.salesOrder = salesOrder;
    this.itemNumber = itemNumber;
    this.syncStatus = syncStatus;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdSdProjectNetwork();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectDefinition',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.grid.projectDefinition',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'networkWbs',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.grid.networkWbs',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'networkCode',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.grid.networkCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'decription',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.grid.decription',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'salesOrder',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.grid.salesOrder',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'itemNumber',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.grid.itemNumber',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'syncStatus',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.grid.syncStatus',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    projectDefinitionFilter : "",
    networkWbsFilter : "",
    networkCodeFilter : "",
    decriptionFilter : "",
    salesOrderFilter : "",
    itemNumberFilter : "",
    syncStatusFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'projectDefinitionFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.filter.projectDefinition',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'networkWbsFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.filter.networkWbs',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'networkCodeFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.filter.networkCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'decriptionFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.filter.decription',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'salesOrderFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.filter.salesOrder',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'itemNumberFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.filter.itemNumber',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'syncStatusFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.filter.syncStatus',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'projectDefinition',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.entity.projectDefinition',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'networkWbs',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.entity.networkWbs',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'networkCode',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.entity.networkCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'decription',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.entity.decription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'salesOrder',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.entity.salesOrder',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'itemNumber',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.entity.itemNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'syncStatus',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.entity.syncStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdSdProjectNetwork.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdSdProjectNetwork, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
